import React from "react";

import { ApplicationDetails } from "../../layouts/applicationDetails/ApplicationDetails";

const ApplicationDetailsSitecore = (props) => <ApplicationDetails fields={props.fields} />;

export default ApplicationDetailsSitecore;
